// app/frontend/components/ui/DropdownMenu.tsx
// Wrapper around shadcn/ui dropdown-menu with default styling

import * as React from 'react'
import { cn } from '@/lib/utils'
import {
  DropdownMenu as ShadcnDropdownMenu,
  DropdownMenuTrigger as ShadcnDropdownMenuTrigger,
  DropdownMenuContent as ShadcnDropdownMenuContent,
  DropdownMenuItem as ShadcnDropdownMenuItem,
  DropdownMenuCheckboxItem as ShadcnDropdownMenuCheckboxItem,
  DropdownMenuRadioItem as ShadcnDropdownMenuRadioItem,
  DropdownMenuLabel as ShadcnDropdownMenuLabel,
  DropdownMenuSeparator as ShadcnDropdownMenuSeparator,
  DropdownMenuShortcut as ShadcnDropdownMenuShortcut,
  DropdownMenuGroup as ShadcnDropdownMenuGroup,
  DropdownMenuPortal as ShadcnDropdownMenuPortal,
  DropdownMenuSub as ShadcnDropdownMenuSub,
  DropdownMenuSubContent as ShadcnDropdownMenuSubContent,
  DropdownMenuSubTrigger as ShadcnDropdownMenuSubTrigger,
  DropdownMenuRadioGroup as ShadcnDropdownMenuRadioGroup,
} from '@/components/ui/shadcn/dropdown-menu'

// Re-export unchanged components
const DropdownMenu = ShadcnDropdownMenu
const DropdownMenuTrigger = ShadcnDropdownMenuTrigger
const DropdownMenuContent = ShadcnDropdownMenuContent
const DropdownMenuCheckboxItem = ShadcnDropdownMenuCheckboxItem
const DropdownMenuRadioItem = ShadcnDropdownMenuRadioItem
const DropdownMenuLabel = ShadcnDropdownMenuLabel
const DropdownMenuSeparator = ShadcnDropdownMenuSeparator
const DropdownMenuShortcut = ShadcnDropdownMenuShortcut
const DropdownMenuGroup = ShadcnDropdownMenuGroup
const DropdownMenuPortal = ShadcnDropdownMenuPortal
const DropdownMenuSub = ShadcnDropdownMenuSub
const DropdownMenuSubContent = ShadcnDropdownMenuSubContent
const DropdownMenuSubTrigger = ShadcnDropdownMenuSubTrigger
const DropdownMenuRadioGroup = ShadcnDropdownMenuRadioGroup

interface DropdownMenuItemProps extends React.ComponentProps<typeof ShadcnDropdownMenuItem> {}

// Wrapped DropdownMenuItem with default spacing
function DropdownMenuItem({ className, ref, ...props }: DropdownMenuItemProps) {
  return (
    <ShadcnDropdownMenuItem
      ref={ref}
      className={cn("my-0.5", className)}
      {...props}
    />
  )
}

export {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuCheckboxItem,
  DropdownMenuRadioItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuGroup,
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuRadioGroup,
}
